/**
 * Propane Council Resource Card
 */

// Vendors
import $ from 'jquery';

$('html').on('click', '[data-download-council-resource]', (event) => {
  event.preventDefault();
  const postId = $(event.currentTarget).data('download-council-resource');

  $.ajax({
    type: 'POST',
    url: '/wp-admin/admin-ajax.php?action=add_council_resource_download',
    dataType: 'json',
    data: { post_id: postId },
    success: (response) => {
      if (response.data.redirect_url)
        window.open(response.data.redirect_url, '_blank');
    },
    error: (jqXHR, exception) => {
      console.error('There was an error downloading the resource.');
    }
  });
});
